import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/** Negativo em vermelho; o resto no azul-escuro da identidade. */
const corDoValor = (valor) => (String(valor).includes('-') ? '#B3261E' : 'secondary.main');

/**
 * Faixa de indicadores do relatório (saldo total, contas, ticket médio...).
 *
 * Os números vêm calculados pelo back-end sobre **todo o conjunto filtrado** —
 * não sobre a página da tabela nem sobre as linhas que a busca local deixou
 * visíveis. Recalcular aqui a partir das linhas daria outro valor a cada
 * mudança de página, que é justamente o erro que se quer evitar.
 *
 * O rótulo e a ordem também vêm de lá (`RotulosTotais`), e são os mesmos do
 * PDF. Enquanto essa tabela de rótulos existia aqui e dentro de cada template,
 * o cartão da tela e o do papel podiam dizer coisas diferentes do mesmo número.
 */
export default function IndicadoresRelatorio({ indicadores }) {
    const itens = Array.isArray(indicadores) ? indicadores : [];
    if (itens.length === 0) return null;

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: 'repeat(2, 1fr)',
                    sm: 'repeat(3, 1fr)',
                    md: `repeat(${Math.min(itens.length, 6)}, 1fr)`,
                },
                gap: 1.5,
                mb: 2,
            }}
        >
            {itens.map(i => (
                <Paper key={i.chave} variant="outlined" sx={{ p: 1.5 }}>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block', lineHeight: 1.3 }}
                    >
                        {i.rotulo}
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 600, color: corDoValor(i.valor),
                            // Valor longo ("Prejuízo no período") não pode
                            // estourar o cartão nem forçar scroll na página.
                            fontSize: i.valor.length > 14 ? '0.95rem' : '1.15rem',
                            lineHeight: 1.35,
                            wordBreak: 'break-word',
                        }}
                    >
                        {i.valor}
                    </Typography>
                </Paper>
            ))}
        </Box>
    );
}
